import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { CreateUserParams, createUser } from '@utils/backend-api/users';

const useUserCreate = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: CreateUserParams) => createUser(params),
    {
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(error.message);
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
      onSuccess: (response) => {
        if (
          ['/subscribe', '/subscribe_h'].includes(window.location.pathname) &&
          response.userWasCreated
        ) {
          window['optimizely'] = window['optimizely'] || [];
          window['optimizely'].push({
            type: 'event',
            eventName: 'subscribe-page-lead',
            tags: {
              revenue: 0, // Optional in cents as integer (500 == $5.00)
              value: 0.0, // Optional as float
            },
          });
        }
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useUserCreate;
